import { types } from "mobx-state-tree";
import UserPermission from "./UserPermission";

const UserPermissionStore = types
  .model('UserPermisssionStore', {
    permissions: types.optional(types.array(UserPermission), []),
  })
  .actions((self) => ({
    setPermissions(permissions) {
      let newPermissions = [];
      for (let i = 0; i < permissions.length; i++) {
        newPermissions.push(UserPermission.create(permissions[i]));
      }
      self.permissions = [...newPermissions];
    },
  }))
  .views((self) => ({
    havePermissions(pComponent, pPermissions) {
      return (
        self.permissions.filter(
          (perm) =>
            perm.component === pComponent &&
            pPermissions.indexOf(perm.permission) > -1 &&
            perm.permitted
        ).length === pPermissions.length
      );
    },
  }));

export default UserPermissionStore;
